import React from 'react'
import { t } from 'ttag'
import styles from './TopAreas.module.scss'
import { capitalizeFirstLetter } from 'utils/stringFormat'

const getTopCategories = data => {
  const stats = data.reduce((acc, { category, value }) => {
    if (!acc[category]) {
      acc[category] = { sum: 0, count: 0 }
    }
    acc[category].sum += value
    acc[category].count += 1
    return acc
  }, {})

  const averages = Object.entries(stats).map(([category, { sum, count }]) => ({
    category,
    avgValue: sum / count,
  }))

  return averages
    .sort((a, b) => b.avgValue - a.avgValue)
    .slice(0, 5)
    .map(cat => cat.category)
}

const getTopTalentAreas = data => {
  return data
    .sort((a, b) => b.value - a.value)
    .slice(0, 5)
    .map(area => area.area)
}

export const TopAreas = ({ data }) => {
  const topCategories = getTopCategories(data)
  const topTalentAreas = getTopTalentAreas(data)

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.areasTitle}>{t`Top categories`}</div>
        <ul className={styles.list}>
          {topCategories.map(cat => {
            return <li key={cat}>{capitalizeFirstLetter(cat)}</li>
          })}
        </ul>
      </div>
      <div>
        <div className={styles.areasTitle}>{t`Top talent areas`}</div>
        <ul className={styles.list}>
          {topTalentAreas.map(area => {
            return <li key={area}>{area}</li>
          })}
        </ul>
      </div>
    </div>
  )
}
